import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { isNotNullOrEmpty } from '@/shared/lib/core/utils/data-validation.util';

@Pipe({
  name: 'dateTransformPipe',
  standalone: true,
})
export class DateFormatExtension implements PipeTransform {
  datepipe = inject(DatePipe);

  transform(inputDate: any, format = 'yyyy-MM-dd HH:mm:ss'): string | null {
    try {
      if (isNotNullOrEmpty(inputDate) && inputDate != 'Invalid Date') {
        if (inputDate === 'now') {
          const newDate = new Date();
          return this.datepipe.transform(newDate, format);
        }

        if (typeof inputDate === 'string') {
          const dateString = inputDate.replace(/(\+\d{2}:\d{2})$/, 'Z').replace(/\.\d+/, '');
          return this.datepipe.transform(new Date(dateString), format)?.toString() ?? null;
        } else {
          return this.datepipe.transform(inputDate, format)?.toString() ?? null;
        }
      }
      return null;
    } catch {
      return null;
    }
  }
}
